import {
  Button,
  Checkbox,
  CircularProgress,
  circularProgressClasses,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { uploadFile, uploadProjAdmin } from '../../Actions/UploadProjectUser';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

var names = [
  'Goal 1',
  'Goal 2',
  'Goal 3',
  'Goal 4',
  'Goal 5',
  'Goal 6',
  'Goal 7',
  'Goal 8',
  'Goal 9',
  'Goal 10',
  'Goal 11',
  'Goal 12',
  'Goal 13',
  'Goal 14',
  'Goal 15',
  'Goal 16',
  'Goal 17',
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const UploadDocForm = () => {
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [enable, setenabled] = useState(false);
  const fileUrl = useSelector(state => state.fileData);
  const fileLoading = useSelector(state => state.fileData.isLoading);
  const loading = useSelector(state => state.signUpData.isLoading);
  const userData = JSON.parse(localStorage.getItem('access_token'));
  const [cat, setCategory] = useState('');
  const [catValue, setCatValue] = useState('');
  const [defValue, setDefValue] = useState('df');
  const [clicked, setClicked] = useState(false);
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [author, setAuthor] = useState([]);
  const [dialogText, setDialogText] = useState('');
  const [dialogText2, setDialogText2] = useState('');
  const [forceRerender, setForceRerender] = useState(true);
  const [personName, setPersonName] = useState([]);
  const [isStudent, setIsStudent] = useState(false);

  const handleDialogText = e => {
    setDialogText(e.target.value);
  };

  const handleDialogText2 = e => {
    setDialogText2(e.target.value);
  };

  const handleDialogSubmit2 = e => {
    e.preventDefault();
    setCategory(dialogText2);
    names.push(dialogText2);
    setOpen2(false);
    toast('New Goal Added');

    // console.log(author);
  };

  const handleDialogSubmit = e => {
    e.preventDefault();
    author.push(dialogText);
    setAuthor(author);
    setOpen(false);
    toast('Author Successfully Added');

    // console.log(author);
  };

  const handleDeleteDialog = auth => {
    const ind = author.indexOf(auth);
    // console.log('auth', auth);
    if (ind > -1) {
      author.splice(ind, 1); // 2nd parameter means remove one item only
    }

    setAuthor(author);
    setForceRerender(!forceRerender);
    // console.log('ew', author);
  };

  useEffect(() => {
    setAuthor(author);
  }, [forceRerender, author]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickOpen2 = () => {
    setOpen2(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOpen2(false);
  };

  useEffect(() => {
    setDefValue(catValue);
  }, [catValue, defValue]);

  const handleCat = e => {
    setCatValue(e.target.value);
  };

  // const handleChange = event => {
  //   event.preventDefault();
  //   setCategory(event.target.value);
  // };
  const handleChange = event => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a the stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const defInd = () => {
    setVisible(true);
    setClicked(true);
    setOpen2(true);
  };

  const onFileSelected = e => {
    if (e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
      setFileName(e.target.files[0].name);
    }
  };

  const handleFileUpload = async e => {
    e.preventDefault();
    try {
      if (selectedFile !== '') {
        let fileData = new FormData();
        if (selectedFile.type === 'application/pdf') {
          fileData.set('File', selectedFile, `${Date.now()}.pdf`);
          dispatch(uploadFile(fileData));
          setenabled(true);
        } else toast('Error file uploaded is not of the format .pdf');
      }
    } catch (error) {
      toast(error.message);
    }
  };

  const num = /^[0-9]+$/;

  const validate = Yup.object().shape({
    name: Yup.string().required('Required'),
    title: Yup.string().required('Required'),
    empID: Yup.string()
      .matches(num, 'Employee ID must be a number')
      .min(1, 'Too Short!')
      .max(10, 'Too Long!')
      .required('Required'),
    department: Yup.string().required('Required'),
    projDepartment: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
    startDate: Yup.string().required('Required'),
    endDate: Yup.string().required('Required'),
    Coursename: Yup.string().required('Required'),
    Courseid: Yup.string().required('Required'),
  });

  const formik = useFormik({
    initialValues: {
      title: '',
      projDepartment: '',
      projCatergory: '',
      description: '',
      name: '',
      department: '',
      startDate: '',
      endDate: '',
      empID: '',
      Coursename: '',
      Courseid: '',
    },
    validationSchema: validate,

    onSubmit: (values, onSubmitProps) => {
      new Date(values.startDate).getTime() <= new Date(values.endDate).getTime()
        ? dispatch(
            uploadProjAdmin(
              {
                title: values.title,
                category: personName,
                description: values.description,
                projectDepartment: values.projDepartment,
                startDate: values.startDate,
                endDate: values.endDate,
                name: values.name,
                empID: values.empID,
                department: values.department,
                fileName: fileUrl.newsData,
                authors: author,
                CourseName: values.Coursename,
                CourseId: values.Courseid,
              },
              userData.token,
            ),
          )
        : toast('START DATE CANNOT BE GREATER THAN END DATE');

      // setOpen(true);
      onSubmitProps.resetForm();
      setClicked(false);
      setCatValue('');
      setDefValue('');
      setPersonName([]);
      //   const formData = new FormData();
      // formData.append('File', selectedFile);
    },
  });

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <form onSubmit={formik.handleSubmit}>
        <Grid
          Container
          sx={{
            marginTop: 5,
            display: 'flex',
            flexDirection: ['column', 'column', 'row'],
          }}
          spacing={0}
        >
          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
            <Typography variant="h5" sx={{ fontFamily: 'Sora', color: 'black', fontWeight: 'bold' }}>
              Enter Your Details
            </Typography>
          </Grid>
        </Grid>
        <Grid
          Container
          sx={{
            marginTop: 6,
            display: 'flex',
            gap: '25px',
            flexDirection: ['column', 'column', 'row'],
          }}
          spacing={0}
        >
          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
            <TextField
              variant="standard"
              id="title"
              name="title"
              value={formik.values.title}
              onChange={formik.handleChange}
              error={formik.touched.title && Boolean(formik.errors.title)}
              helperText={formik.touched.title && formik.errors.title}
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
              placeholder="Enter Your Project Title*"
              size="small"
              sx={{
                width: '300px',
                // marginRight: '30px',
                p: 2,
                borderRadius: 2,
                backgroundColor: 'white',
                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                },
              }}
            />
          </Grid>

          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
            <TextField
              variant="standard"
              id="projDepartment"
              name="projDepartment"
              value={formik.values.projDepartment}
              onChange={formik.handleChange}
              error={formik.touched.projDepartment && Boolean(formik.errors.projDepartment)}
              helperText={formik.touched.projDepartment && formik.errors.projDepartment}
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
              placeholder="Enter Your Project Department*"
              size="small"
              sx={{
                width: '300px',
                backgroundColor: 'white',
                p: 2,
                borderRadius: 2,
                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                },
              }}
            />
          </Grid>
          <Grid item md={4} xs={12} sm={12} sx={{ display: 'flex', flexDirection: 'row' }}>
            <FormControl sx={{ marginTop: ['20px', '20px', 1], width: '12vw', marginRight: 1 }}>
              <InputLabel
                id="demo-simple-select-label"
                sx={{ fontFamily: 'Sora', fontSize: '14px', fontWeight: 'bold', opacity: 0.5 }}
              >
                Category
              </InputLabel>

              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput label="Tag" />}
                renderValue={selected => selected.join(', ')}
                MenuProps={MenuProps}
              >
                {names.map(name => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.indexOf(name) > -1} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <IconButton
              component="span"
              onClick={handleClickOpen2}
              sx={{ height: '50px', width: '50px', color: '#FF7345', marginTop: '2px', paddingTop: [6, 6, 2, 2] }}
            >
              <AddCircleIcon sx={{ height: '50px', width: '50px', display: 'flex', justifyContent: 'center' }} />
            </IconButton>
            <Dialog open={open2} onClose={handleClose}>
              <DialogTitle sx={{ width: ['100%', '100%', '500px'], fontFamily: 'Sora' }}>ADD A NEW GOAL</DialogTitle>
              <DialogContent>
                <DialogContentText sx={{ fontFamily: 'Sora' }}>Enter the name of the goal</DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Name"
                  fullWidth
                  variant="standard"
                  onChange={handleDialogText2}
                  value={dialogText2}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleClose}
                  sx={{
                    backgroundColor: '#F95329',
                    color: 'white',
                    border: 0,

                    fontFamily: 'Sora',

                    '&:hover': {
                      backgroundColor: 'red',
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleDialogSubmit2}
                  sx={{
                    backgroundColor: '#FF7345',
                    color: 'white',
                    border: 0,

                    fontFamily: 'Sora',

                    '&:hover': {
                      backgroundColor: '#d95429',
                    },
                  }}
                >
                  Add
                </Button>
              </DialogActions>
            </Dialog>

            <TextField
              variant="standard"
              id="category"
              name="category"
              value={catValue}
              onChange={handleCat}
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
              placeholder="Enter Your Project Category*"
              size="small"
              sx={
                visible
                  ? {
                      width: '300px',
                      visible: 'false',
                      backgroundColor: 'white',
                      p: 1,
                      borderRadius: 2,
                      '& input::placeholder': {
                        fontFamily: 'Sora',
                        fontSize: '13px',
                        fontWeight: 'bold',
                      },
                    }
                  : {
                      width: '300px',
                      visible: 'false',
                      display: 'none',
                      p: 1,
                      borderRadius: 2,
                      '& input::placeholder': {
                        fontFamily: 'Sora',
                        fontSize: '13px',
                        fontWeight: 'bold',
                      },
                    }
              }
            />
          </Grid>
        </Grid>
        <Grid
          Container
          sx={{
            my: 2,
            display: 'flex',
            // gap: '15vw',
            // width: '100%',
            // height: '15vh',
            // flexDirection: ['column', 'column', 'row'],
          }}
        >
          <Grid sx={{ marginTop: '10px' }}>
            <Typography sx={{ fontFamily: 'Sora', opacity: 0.3, fontSize: '14px', my: 1, fontWeight: 'bold', p: 2 }}>
              Enter Your Project Description*
            </Typography>
            <TextField
              // placeholder="Enter Your Project Description*"
              id="description"
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              error={formik.touched.description && Boolean(formik.errors.description)}
              helperText={formik.touched.description && formik.errors.description}
              variant="standard"
              // placeholder="Enter Your Project Description*"

              sx={{
                width: '700px',
                height: '150px',
                borderRadius: 2,
                backgroundColor: 'white',
                // height: '100px',
                p: 2,
                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                },
              }}
              multiline
              maxRows="4"
              minRows="2"
              InputProps={{
                disableUnderline: true,

                // style: { color: "#703C00" },
              }}
            />
          </Grid>
        </Grid>
        <Grid item md={6} sm={12} sx={{ marginTop: '4vh', p: 1 }} xs={12}>
          {/* <form>
            <input type="file"  onChange={changeHandler} />
            <button onClick={handleSubmission}>Submit</button>
            </form> */}

          <input type="file" onChange={onFileSelected} style={{ marginRight: 0, marginBottom: 20 }} />
          {fileLoading ? (
            <CircularProgress />
          ) : (
            <Button
              sx={{
                backgroundColor: '#FF7345',
                color: 'white',
                border: 0,
                width: '100px',
                fontFamily: 'Sora',
                marginBottom: '7px',
                '&:hover': {
                  backgroundColor: '#d95429',
                },
              }}
              type="submit"
              onClick={e => handleFileUpload(e)}
              className="btn"
            >
              Upload
            </Button>
          )}
          <Typography sx={{ fontFamily: 'Sora', color: 'red', fontSize: '13px' }}>*Please upload .pdf only</Typography>
        </Grid>
        <Grid
          Container
          sx={{
            display: 'flex',
            flexDirection: ['column', 'column', 'row'],
          }}
          spacing={0}
        >
          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px', display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ fontFamily: 'Sora', px: 1, fontWeight: 'bold', opacity: 0.5 }}>Start Date</Typography>

            <TextField
              id="startDate"
              name="startDate"
              value={formik.values.startDate}
              onChange={formik.handleChange}
              error={formik.touched.startDate && Boolean(formik.errors.startDate)}
              helperText={formik.touched.startDate && formik.errors.startDate}
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
              type="date"
              sx={{ width: 220, backgroundColor: 'white' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
            sm={12}
            sx={{ marginTop: '10px', display: 'flex', flexDirection: 'column', marginLeft: [0, 0, '200px'] }}
          >
            <Typography sx={{ fontFamily: 'Sora', px: 1, fontWeight: 'bold', opacity: 0.5 }}>End Date</Typography>

            <TextField
              id="endDate"
              name="endDate"
              value={formik.values.endDate}
              onChange={formik.handleChange}
              error={formik.touched.endDate && Boolean(formik.errors.endDate)}
              helperText={formik.touched.endDate && formik.errors.endDate}
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
              type="date"
              sx={{ width: 220, backgroundColor: 'white' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          Container
          sx={{
            marginTop: 3,
            display: 'flex',
            gap: '25px',
            flexDirection: ['column', 'column', 'row'],
          }}
          spacing={0}
        >
          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
            <TextField
              variant="standard"
              id="name"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
              placeholder="Enter Your Name*"
              size="small"
              sx={{
                width: '250px',
                p: 2,
                borderRadius: 2,
                backgroundColor: 'white',
                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                },
              }}
            />
          </Grid>
          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
            <TextField
              variant="standard"
              id="empID"
              name="empID"
              value={formik.values.empID}
              onChange={formik.handleChange}
              error={formik.touched.empID && Boolean(formik.errors.empID)}
              helperText={formik.touched.empID && formik.errors.empID}
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
              placeholder="Enter Your Id*"
              size="small"
              sx={{
                width: '250px',
                backgroundColor: 'white',
                p: 2,
                borderRadius: 2,
                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                },
              }}
            />
          </Grid>
          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
            <TextField
              variant="standard"
              id="department"
              name="department"
              value={formik.values.department}
              onChange={formik.handleChange}
              error={formik.touched.department && Boolean(formik.errors.department)}
              helperText={formik.touched.department && formik.errors.department}
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
              // InputProps={{
              //   disableUnderline: true,
              //     style: { color: "#703C00" },
              // }}
              placeholder="Enter Your Department*"
              size="small"
              sx={{
                width: '250px',
                backgroundColor: 'white',
                p: 2,
                borderRadius: 2,
                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                },
              }}
            />
          </Grid>
        </Grid>
        <Grid
          Container
          sx={{
            marginTop: 3,
            display: 'flex',
            gap: '25px',
            flexDirection: ['column', 'column', 'row'],
          }}
          spacing={0}
        >
          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
            <TextField
              variant="standard"
              id="Coursename"
              name="Coursename"
              value={formik.values.Coursename}
              onChange={formik.handleChange}
              error={formik.touched.Coursename && Boolean(formik.errors.Coursename)}
              helperText={formik.touched.Coursename && formik.errors.Coursename}
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
              placeholder="Enter Your Course Name*"
              size="small"
              sx={{
                width: '250px',
                p: 2,
                borderRadius: 2,
                backgroundColor: 'white',
                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                },
              }}
            />
          </Grid>
          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
            <TextField
              variant="standard"
              id="Courseid"
              name="Courseid"
              value={formik.values.Courseid}
              onChange={formik.handleChange}
              error={formik.touched.Courseid && Boolean(formik.errors.Courseid)}
              helperText={formik.touched.Courseid && formik.errors.Courseid}
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
              placeholder="Enter Your Course Code*"
              size="small"
              sx={{
                width: '250px',
                backgroundColor: 'white',
                p: 2,
                borderRadius: 2,
                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                },
              }}
            />
          </Grid>

          <Grid item md={4} xs={12} sm={12} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <FormControl sx={{ width: '75%' }}>
              <InputLabel
                id="demo-simple-select-label"
                sx={{ fontFamily: 'Sora', fontSize: '14px', fontWeight: 'bold', opacity: 0.5 }}
              >
                Authors
              </InputLabel>

              <Select
                value={cat}
                autoWidth
                label="Authors"
                sx={{ width: '12vw', fontFamily: 'Sora', backgroundColor: 'white', height: '50%' }}
              >
                {author.length ? (
                  author.map(auth => (
                    <MenuItem
                      sx={{
                        fontFamily: 'Sora',
                        display: 'flex',
                        width: '12vw',
                        justifyContent: 'space-between',
                      }}
                      value={auth}
                    >
                      {auth}{' '}
                      <IconButton onClick={() => handleDeleteDialog(auth)}>
                        {' '}
                        <DeleteIcon />
                      </IconButton>
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem
                    sx={{
                      fontFamily: 'Sora',
                      display: 'flex',
                      width: '12vw',
                      justifyContent: 'space-between',
                    }}
                    value="No Added Authors"
                  >
                    Its Empty
                  </MenuItem>
                )}
              </Select>
            </FormControl>

            <IconButton
              component="span"
              onClick={handleClickOpen}
              sx={{ height: '50px', width: '50px', color: '#FF7345', marginTop: '2px', ml: '10px' }}
            >
              <AddCircleIcon sx={{ height: '50px', width: '50px', display: 'flex', justifyContent: 'center' }} />
            </IconButton>
            <Dialog open={open} onClose={handleClose}>
              <DialogTitle sx={{ width: ['100%', '100%', '500px'], fontFamily: 'Sora' }}>ADD AUTHOR</DialogTitle>
              <DialogContent>
                <DialogContentText sx={{ fontFamily: 'Sora' }}>Enter the name of the author</DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Name"
                  fullWidth
                  variant="standard"
                  onChange={handleDialogText}
                  value={dialogText}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleClose}
                  sx={{
                    backgroundColor: '#F95329',
                    color: 'white',
                    border: 0,

                    fontFamily: 'Sora',

                    '&:hover': {
                      backgroundColor: 'red',
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleDialogSubmit}
                  sx={{
                    backgroundColor: '#FF7345',
                    color: 'white',
                    border: 0,

                    fontFamily: 'Sora',

                    '&:hover': {
                      backgroundColor: '#d95429',
                    },
                  }}
                >
                  Add
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        </Grid>
        <Grid
          Container
          sx={{
            marginTop: 1,
            display: 'flex',
            flexDirection: ['column', 'column', 'row'],
            // justifyContent:"space-between"
            alignItems: 'center',
          }}
        >
          <Grid
            item
            md={4}
            xs={12}
            sm={12}
            sx={{
              display: 'flex',
              flexDirection: ['row', 'row', 'row'],
              justifyContent: 'left',
              alignItems: 'center',
              my: [3, 3, 0],
            }}
          >
            <Checkbox required={true}
              value={isStudent}
              onChange={() => { setIsStudent(!isStudent) }} />
            <Typography sx={{ fontFamily: 'Sora', px: 1, fontWeight: 'bold', opacity: 0.5 }}>
              Were students involved during this research work?
            </Typography>

          </Grid>


          {/* <Grid
            item
            md={4}
            xs={12}
            sm={12}
            sx={{ display: 'flex', flexDirection: ['column', 'column', 'row'], justifyContent: 'left', alignItems: 'center', my: [1, 1, 0] }}
          >
            <Checkbox defaultChecked required={true} /> <Typography> Were students involved during this research work?  </Typography>
          </Grid> */}

          <Grid
            item
            md={4}
            xs={12}
            sm={12}
            sx={{
              display: 'flex',
              flexDirection: ['column', 'column', 'row'],
              justifyContent: 'left',
              my: [1, 1, 1],
              p: 2,
            }}
          >


          </Grid>
        </Grid>
        {
          isStudent ?
            <Grid
              Container
              sx={{
                marginTop: 3,
                display: 'flex',
                flexDirection: ['column', 'column', 'row'],
              }}
              spacing={0}
            >
              <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
                <TextField
                  variant="standard"
                  id="name"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                  InputProps={{
                    disableUnderline: true,
                    //   style: { color: "#703C00" },
                  }}
                  placeholder="Enter Student Name*"
                  size="small"
                  sx={{
                    width: '300px',
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: 'white',
                    '& input::placeholder': {
                      fontFamily: 'Sora',
                      fontSize: '13px',
                      fontWeight: 'bold',
                    },
                  }}
                />
              </Grid>
              <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
                <TextField
                  variant="standard"
                  id="empID"
                  name="empID"
                  value={formik.values.empID}
                  onChange={formik.handleChange}
                  error={formik.touched.empID && Boolean(formik.errors.empID)}
                  helperText={formik.touched.empID && formik.errors.empID}
                  InputProps={{
                    disableUnderline: true,
                    //   style: { color: "#703C00" },
                  }}
                  placeholder="Enter Student Id*"
                  size="small"
                  sx={{
                    width: '300px',
                    backgroundColor: 'white',
                    p: 2,
                    borderRadius: 2,
                    '& input::placeholder': {
                      fontFamily: 'Sora',
                      fontSize: '13px',
                      fontWeight: 'bold',
                    },
                  }}
                />
              </Grid>
              <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
                <TextField
                  variant="standard"
                  id="department"
                  name="department"
                  value={formik.values.department}
                  onChange={formik.handleChange}
                  error={formik.touched.department && Boolean(formik.errors.department)}
                  helperText={formik.touched.department && formik.errors.department}
                  InputProps={{
                    disableUnderline: true,
                    //   style: { color: "#703C00" },
                  }}
                  // InputProps={{
                  //   disableUnderline: true,
                  //     style: { color: "#703C00" },
                  // }}
                  placeholder="Enter Student Department*"
                  size="small"
                  sx={{
                    width: '300px',
                    backgroundColor: 'white',
                    p: 2,
                    borderRadius: 2,
                    '& input::placeholder': {
                      fontFamily: 'Sora',
                      fontSize: '13px',
                      fontWeight: 'bold',
                    },
                  }}
                />
              </Grid>
            </Grid> : null}
        {enable === true ? (
          <Button
            variant="outlined"
            sx={{
              backgroundColor: '#67CB45',
              color: 'white',
              border: 0,
              width: ['100%', '100%', '100%'],
              fontFamily: 'Sora',
              display: 'flex',
              height: '85%',
              justifyContent: 'center',

              '&:hover': {
                backgroundColor: '#67CB45',
              },
            }}
            type="submit"
          >
            Submit
          </Button>
        ) : loading ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress />
          </div>
        ) : (
          <Button
            variant="outlined"
            disabled="true"
            sx={{
              backgroundColor: '#67CB45',
              color: 'white',
              border: 0,
              width: ['100%', '100%', '85%'],
              height: '70%',
              fontFamily: 'Sora',

              '&:hover': {
                backgroundColor: '#67CB45',
              },
              display: 'flex',
              justifyContent: 'center',
            }}
            type="submit"
          >
            Submit
          </Button>
        )}
      </form>
    </div>
  );
};

export default UploadDocForm;
